export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_BASE_URL = 'SET_BASE_URL';
export const INIT_SERVER_CART = 'INIT_SERVER_CART';
export const INIT_CLIENT_CART = 'INIT_CLIENT_CART';
export const SET_REDUX_TYPE = 'SET_REDUX_TYPE';
export const SET_CART_TYPE = 'SET_CART_TYPE';
